import React from "react"
import styled from "styled-components"

function IndustryChevron(props) {
  return (
    <svg
      className={props.className}
      width="32"
      height="8"
      viewBox="0 0 35 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.5 0.770264L16.6055 8.32305C17.1686 8.60458 17.8313 8.60458 18.3944 8.32305L33.5 0.770264"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default styled(IndustryChevron)``;